import { Suspense } from "react";

import Loader from "core/components/Loader";
import AppLayout from "./AppLayout";

const LazyAppRoute = ({ children, ...props }) => {
  return (
    <AppLayout {...props}>
      <Suspense fallback={<Loader style={{ paddingBottom: "20vh" }} />}>
        {children}
      </Suspense>
    </AppLayout>
  );
};
export default LazyAppRoute;
